export const strings = {
  english: {
    title: 'LOGIN',
    email: 'Email',
    password: 'Password',
    remember: 'Remember Me',
    lostPassword: "I don't remember my password",
    signIn: 'SIGN IN',
    or: 'Or',
    facebook: 'Continue with Facebook',
    google: 'Continue with Google',
  },

  japan: {
    title: 'ログイン',
    email: 'メールアドレス',
    password: 'パスワード',
    remember: 'ログイン状態を保存',
    lostPassword: 'パスワードをお忘れですか ?',
    signIn: 'サインイン',
    or: 'または',
    facebook: 'Facebookを使ってサインインする',
    google: 'Googleを使ってサインインする',
  },
};
